import * as React from "react";
import * as Moment from 'moment';
import Modal from "../misc/components/modal";
import { AuditModalBody } from "../auditmodal/components/AuditModalBody";
import { RandomizationForm, RandomizationModalBody } from "./RandomizationModalBody";
import { Subject } from "../misc/api/apiTypes";
import LoadingWithMessage from "../misc/components/LoadingWithMessage";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";

interface ToggleRandomizationModalProps {
    subjectId: string;
    onClose: () => void;
}

export const ToggleRandomizationModal = ({ subjectId, onClose }: ToggleRandomizationModalProps) => {
    const [submitting, setSubmitting] = React.useState(false);
    const [confirmed, setConfirmed] = React.useState(false);
    const [subject, setSubject] = React.useState<Subject>();
    const [randomizationFormData, setRandomizationFormData] = React.useState<RandomizationForm>();
    const [errorAlert, setErrorAlert] = React.useState<string>(null);
    const legacyClient = useWebPortalLegacyClient();

    const Client = useWebPortalApiClient();

    React.useEffect(() => {
        const getData = async () => {
            const subject = await legacyClient.getSubject(subjectId);
            const currentDateString = Moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            if (subject.RandomisedStatus) {
                
                subject.RandomisedDateTime = Moment(new Date(subject.RandomisedDateTime)).format("YYYY-MM-DD HH:mm:ss");

            } else {
                subject.RandomisedDateTime = currentDateString;
            }
            setSubject(subject);
            setRandomizationFormData({
                SubjectNumber: subject.SubjectNumber,
                IsRandomized: subject.RandomisedStatus,
                RandomizationNumber: subject.RandomisedId,
                RandomizationDate: subject.RandomisedDateTime,
            } as RandomizationForm);
        }

        getData();
    }, []);

    const onHandleRandomizationModalSubmit = async (form: RandomizationForm) => {
        // Check if there is changes being made
        if (JSON.stringify(form) === JSON.stringify(randomizationFormData)) {
            onClose();
            return;
        }

        setRandomizationFormData({
            SubjectNumber: form.SubjectNumber,
            IsRandomized: form.IsRandomized,
            RandomizationNumber: form.RandomizationNumber,
            RandomizationDate: form.RandomizationDate
        } as RandomizationForm);

        setConfirmed(true); //to bring out the audit modal body
    }

    const onHandleModalSubmit = async (data: RandomizationForm) => {
        setSubmitting(true);
        setErrorAlert(null);

        try {
            await Client.client.patchSubjects({
                randomizationNumber: data.IsRandomized ? data.RandomizationNumber : null,
                randomized: data.IsRandomized ? data.RandomizationDate : null
            }, subjectId, "");
            onClose();
        } catch (ex) {
            setErrorAlert(ex.message);
        }


        setSubmitting(false);
        
    }

    return (
        
        <Modal show={true} header="Update Subject Randomization" automationId="Modal">
            <Alert show={errorAlert !== null} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            {
                !randomizationFormData ? <LoadingWithMessage message="Loading Subject..." />
                    :
                confirmed ?
                    <AuditModalBody isAuditAnnotationDisabled={false} isSubmitting={submitting} onSubmit={() => onHandleModalSubmit(randomizationFormData)} onClose={onClose} annotationLabel="Update Randomization Reason" submitLabel="Update Randomization" />
                    :
                    <RandomizationModalBody studyId={subject.StudyId} subjectId={subject.Id} initialValues={randomizationFormData} onClose={onClose} onSubmit={(form) => { onHandleRandomizationModalSubmit(form) }} />
            }
        </Modal>
    );
}
